import { sameNodePosition, } from "../../components/markdown/utils";
import { cva } from "class-variance-authority";
import React, { memo } from "react";
export const preBlockVariants = cva(["my-2 w-full break-all rounded-2xl border", "border-border"], {
    variants: {
        variant: {
            surface: "bg-muted-background",
        },
    },
});
export const PreBlock = memo(({ children, variant = "surface" }) => {
    var _a, _b, _c;
    const validChildrenContent = Array.isArray(children) && children[0]
        ? children[0].props.children[0]
        : null;
    let fallbackData = null;
    if (!validChildrenContent) {
        fallbackData =
            Array.isArray(children) && children[0]
                ? (_c = (_b = (_a = children[0].props) === null || _a === void 0 ? void 0 : _a.node) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta
                : null;
    }
    return (React.createElement("pre", { className: preBlockVariants({ variant }) }, validChildrenContent ? children : fallbackData || children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.variant === next.variant);
PreBlock.displayName = "PreBlock";
//# sourceMappingURL=PreBlock.js.map